import { ORDER_GOODS_TYPE } from 'lib/constants/order';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import React, { useEffect, useState } from 'react';

function Container({ children, commonStyle }) {
  const userOrderInfo = useUserOrderStore((state) => state.userOrderInfo);
  const [showBenefit, setShowBenefit] = useState(true);
  useEffect(() => {
    // pType表示订购商品类型，3为权益商品，如果非权益商品则不展示权益礼包
    if (userOrderInfo?.pType && userOrderInfo.pType !== ORDER_GOODS_TYPE.BENEFIT) {
      setShowBenefit(false);
    }
  }, [userOrderInfo]);

  return showBenefit ? (
    <div className="container" style={commonStyle}>
      {children}
    </div>
  ) : null;
}

export default Container;
